<template>
    <div class="desktop-view-container">
        <img class="logo" :src="logoB64.length ? logoB64 : require('@/assets/ARGOstqr_Digital_logo_banner.png')" />
        <div v-if="!error" class="content">
            <h1 v-if="$t('desktop.title').length && videoName.length > 0">
                {{ $t("desktop.title") }}
            </h1>
            <transition name="fade" v-show="qrcodeReady" appear>
                <div class="on-ready-container">
                    <!--
                    <div id="video-container" v-if="videoName.length > 0">
                        <video
                            :src="videoUrl"
                            ref="homeVideo"
                            id="home-video"
                            preload="metadata"
                            @click="togglePlay"
                        />
                        <img
                            @click="togglePlay"
                            id="play-button"
                            :src="require('@/assets/play.png')"
                            v-if="!isPlayingVideo"
                        />
                        <FullscreenButton class="fullscreen-btn" @click="goFullscreen" />
                    </div>
                    -->
                    <canvas id="qr-canvas" ref="canvas" />
                    <div
                        class="tutorial"
                        v-if="$t('desktop.tutorial').length && videoName.length > 0"
                        v-html="$t('desktop.tutorial')"
                    />
                    <div
                        class="tutorial"
                        v-if="$t('desktop.tutorialNoMessage').length && videoName.length == 0"
                        v-html="$t('desktop.tutorialNoMessage')"
                    />
                    <div class="tutorial tutorial-2" v-if="$t('desktop.tutorial2').length">
                        {{ $t("desktop.tutorial2") }}
                    </div>
                    <div class="link">{{ currentUrl }}</div>

                    <div class="powered">
                        Powered by <a href="https://ar-go.co" target="_blank"> ARGO</a>
                    </div>
                    <div class="links-container">
                        <a
                            class="link-item"
                            href="https://www.linkedin.com/company/ar-go/"
                            target="_blank"
                        >
                            <span class="icon-linkedin" />
                        </a>
                        <a
                            class="link-item"
                            href="https://twitter.com/argo_group_news"
                            target="_blank"
                        >
                            <span class="icon-twitter" />
                        </a>
                        <a
                            class="link-item"
                            href="https://www.facebook.com/argo.group.news/"
                            target="_blank"
                        >
                            <span class="icon-facebook" />
                        </a>
                        <a
                            class="link-item"
                            href="https://www.instagram.com/argo_augmented_doc/"
                            target="_blank"
                        >
                            <span class="icon-instagram" />
                        </a>
                        <a
                            class="link-item"
                            href="https://www.youtube.com/channel/UC75UOvl-cpQe7rMtpRC7Sgw"
                            target="_blank"
                        >
                            <span class="icon-youtube" />
                        </a>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>
<script lang="ts">
import qrcode from "qrcode";
import { mapState } from "vuex";
import { State } from "@/store";

export default {
    name: "HomeDesktop",
    data() {
        return {
            hasExperience: false,
            experienceId: "",
            videoName: "",
            error: "",
            qrcodeReady: false,
            currentUrl: document.location.href,
            isPlayingVideo: false
        };
    },

    computed: {
        ...mapState({
            qrcodeObject: (state: State) => state.qrcode.qrcodeObject,
            videoUrl: (state: State) => state.qrcode.videoUrl,
            logoB64: (state: State) => state.qrcode.logoB64
        })
    },

    beforeMount() {
        this.hasExperience = this.qrcodeObject.experiences?.length > 0;
        this.videoName =
            this.qrcodeObject.experiences.length > 0
                ? this.qrcodeObject.experiences[0].name
                : this.$t("share.openText");
    },

    mounted() {
        qrcode.toCanvas(this.$refs.canvas, document.location.href, { width: 200 }, error => {
            if (error) {
                console.log("error");
                return;
            }

            this.qrcodeReady = true;
        });

        const videoHome = this.$refs.homeVideo;
        if (videoHome) {
            videoHome.removeEventListener("play", this.onVideoPlay);
            videoHome.removeEventListener("pause", this.onVideoStop);

            videoHome.addEventListener("play", this.onVideoPlay);
            videoHome.addEventListener("pause", this.onVideoStop);
        }
    },

    methods: {
        onVideoPlay() {
            this.isPlayingVideo = true;
        },
        onVideoStop() {
            this.isPlayingVideo = false;
        },
        togglePlay() {
            if (this.isPlayingVideo) {
                this.$refs.homeVideo.pause();
            } else {
                this.$refs.homeVideo.play();
            }
        },
        goFullscreen() {
            this.$refs.homeVideo.requestFullscreen();
        }
    }
};
</script>
<style scoped>
.logo {
    max-height: 130px;
    width: 200px;
    margin-top: 1em;
    cursor: pointer;
}

.error-message {
    font-size: 1.5em;
}

.content {
    color: var(--screenTextColor);
    width: 50%;
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.on-ready-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
}

h1 {
    font-weight: 500;
    margin-top: 12px;
    margin-bottom: 10px;
}

#video-container {
    position: relative;
    max-width: 80vw;
    border-radius: 20px;
    z-index: 20;
}

#home-video {
    max-height: 30vh;
    height: calc(60 * var(--vh));
    width: auto;
    margin: auto;
    transition: all 0.2s ease-in;
    max-width: 100%;
    border-radius: inherit;
    object-fit: cover;
}

#play-button {
    width: 80px;
    height: auto;
    position: absolute;
    left: calc(50% - 40px);
    top: calc(60% - 40px);
}

.fullscreen-btn {
    position: absolute;
    top: 20px;
    right: 20px;
    color: var(--white);
}

#qr-canvas {
    background: var(--white);
    border-radius: 30px;
}

.tutorial {
    font-size: 1.4em;
    margin-top: 30px;
    letter-spacing: -1px;
    width: 80%;
    font-weight: 500;
}

.tutorial.tutorial-2 {
    font-size: 1.2em;
    font-weight: bold;
    width: 100%;
}

.link {
    background: var(--secondary);
    color: var(--buttonTextColor);
    padding: 10px;
    border-radius: 10px;
    font-weight: bold;
    width: 100%;
    margin-top: 10px;
}

.powered {
    margin-top: 45px;
    font-size: 1.25em;
}

.powered a {
    color: inherit;
}

.links-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    margin-bottom: 20px;
}

.link-item {
    background: var(--secondary);
    color: var(--buttonTextColor);
    width: 40px;
    height: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    margin-left: 15px;
    margin-right: 15px;
    text-decoration: none;
    font-size: 20px;
}
</style>
